var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubstack = function SvgSubstack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(5.4592 4.4992)",
    d: "M21.079 8.242H0V5.406H21.08V8.242H21.079ZM0 10.812V24L10.54 18.11L21.08 24V10.812H0ZM21.08 0H0V2.836H21.08V0Z",
    fill: "currentColor"
  })));
};
export default SvgSubstack;